import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import { CreateQuestion } from "./Pages/CreateQuestion";
import QpInterface from "./Pages/QpInterface";
import { QpView } from "./Pages/QpView";
import { ViewFullPaper } from "./Pages/ViewFullPaper";

const Router = createBrowserRouter([
    {
        path: "/",
        element: <App /> 
    },
    {
        path: "/qp-interface",
        element: <QpInterface />
    },
    {
        path: "/qp-view/:id",
        element: <QpView />
    },
    {
        path: "/create-question",
        element: <CreateQuestion />
    },
    {
        path: "/create-question/:id",
        element: <CreateQuestion />
    },
    {
        path: "/view-full-paper",
        element: <ViewFullPaper />
    }
])

export default Router;